import { useCallback } from "react";
import { atom, selector, useRecoilRefresher_UNSTABLE, useSetRecoilState } from "recoil";
import { useRecoilValue } from "recoil";
import axios from "axios";
import { executeLinksAPI } from "../utils/LinksAPI";
import { COMMUNICATE_ERROR_MESSAGE_CUSTOMER_EXTERNAL_FILE_LIST, COMMUNICATE_ERROR_MESSAGE_CUSTOMER_ICON, COMMUNICATE_ERROR_MESSAGE_CUSTOMER_POINT, COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER } from "../constants/ErrorMessage";
import { getCustomer } from "../Authorization";
import { userState } from "./UserState";
import { MAP_ID_CUSTOM_POINT_AREA, mapContentsVisibleWithID } from "./MapContentsState";

// API
// Customer Icon
const _registerCustomerIcon = async (data) => {
	const config = {
		method: 'POST',
		data: data
	};

	return await executeLinksAPI('fosterlinks/customer_icon', config);
};

const _updateCustomerIcon = async (data) => {
	const config = {
		method: 'PUT',
		data: data
	};

	return await executeLinksAPI('fosterlinks/customer_icon', config);
};

const _listCustomerIcon = async () => {
	const config = {
		method: 'GET',
		errorHandle: {
			message: COMMUNICATE_ERROR_MESSAGE_CUSTOMER_ICON,
			additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
		}
	};

	return await executeLinksAPI('fosterlinks/customer_icon', config).catch(() => []);
};

const _deleteCustomerIcon = async (data) => {
	const config = {
		method: 'DELETE',
		data: data
	};

	return await executeLinksAPI('fosterlinks/customer_icon', config);
}

const _registerCustomerIconImage = async (data) => {
	const apiUrl = process.env.REACT_APP_APP_FOSTERLINKS_ADDIN_API_URL;
	const apiKey = process.env.REACT_APP_APP_FOSTERLINKS_ADDIN_API_KEY;
	const config = {
		method: 'POST',
		url: `${apiUrl}/fosterlinks/customer_icon/image/${data.icon_id}`,
		params: {
			'update_time': data.update_time,
			'update_by_user': data.update_by_user
		},
		headers: {
			'x-api-key': apiKey,
			'Content-Type': 'image/png',
		},
		data: data.customer_icon_image_blob,
		withCredentials: true,
	};
	
	// await axios(config)
	// await fetch(config.url, { ...config, body: config.data })
	// axiasのblobのPOSTはこの書式でしか動かない
	await axios.post(config.url, config.data, { headers: config.headers, withCredentials: config.withCredentials, params: config.params })
		.then(response => {
			const res = response.data;
			if (!res) {
				throw new Error(`Resoponse error`);
			}
		})
		.catch(e => {
			console.log('Failed to register aircraft.', e);
			throw new Error(e);
		});
};

//Not implemented
// const _deleteCustomerIconImage = async (data) => {
// 	const config = {
// 		method: 'DELETE',
// 		data: data
// 	};

// 	return await executeLinksAPI('fosterlinks/customer_icon', config);
// }

// Customer Point
const _registerCustomerPoint = async (data) => {
	const config = {
		method: 'POST',
		data: data
	};

	return await executeLinksAPI('fosterlinks/customer_point', config);
};

const _listCustomerPoint = async () => {
	const config = {
		method: 'GET',
		errorHandle: {
			message: COMMUNICATE_ERROR_MESSAGE_CUSTOMER_POINT,
			additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
		}
	};

	return await executeLinksAPI('fosterlinks/customer_point', config).catch(() => []);
};

const _updateCustomerPoint = async (data) => {
	const config = {
		method: 'PUT',
		data: data
	};

	return await executeLinksAPI('fosterlinks/customer_point', config);
};

const _deleteCustomerPoint = async (data) => {
	const config = {
		method: 'DELETE',
		data: data
	};

	return await executeLinksAPI('fosterlinks/customer_point', config);
};

// Customer External File
const _getExternalFileUploadUrl = async (data) => {
	const apiUrl = process.env.REACT_APP_CUSTOMER_FILE_API_URL;
	const apiKey = process.env.REACT_APP_CUSTOMER_FILE_API_KEY;
	const config = {
		method: 'GET',
		url: `${apiUrl}/customer-ext-data/generate-url`,
		headers: {
			'x-api-key': apiKey
		},
		params: data,
	};
	
	return await axios(config)
		.then(response => {
			const res = response.data;
			return res;
		});
};

const _uploadExternalFile = async (url, data) => {
	const config = {
		method: 'PUT',
		url: `${url}`,
		headers: {
			// 'x-api-key': apiKey
			'Content-Type': 'application/geo+json',
		},
		data: data,
	};

	return await axios(config)
		.then(response => {
			const res = response.data;
			return res;
		});
};

const _registerExternalFile = async (data) => {
	const apiUrl = process.env.REACT_APP_CUSTOMER_FILE_API_URL;
	const apiKey = process.env.REACT_APP_CUSTOMER_FILE_API_KEY;
	const config = {
		method: 'POST',
		url: `${apiUrl}/customer-ext-data/geojson/register`,
		headers: {
			'x-api-key': apiKey
		},
		data: data,
	};

	return await axios(config)
		.then(response => {
			const res = response.data;
			return res;
		});
};

const _replaceExternalFile = async (data) => {
	const apiUrl = process.env.REACT_APP_CUSTOMER_FILE_API_URL;
	const apiKey = process.env.REACT_APP_CUSTOMER_FILE_API_KEY;
	const config = {
		method: 'PUT',
		url: `${apiUrl}/customer-ext-data/geojson/replace`,
		headers: {
			'x-api-key': apiKey
		},
		data: data,
	};

	return await axios(config)
		.then(response => {
			const res = response.data;
			return res;
		});
};

const _updateExternalFile = async (data) => {
	const apiUrl = process.env.REACT_APP_CUSTOMER_FILE_API_URL;
	const apiKey = process.env.REACT_APP_CUSTOMER_FILE_API_KEY;
	const config = {
		method: 'PUT',
		url: `${apiUrl}/customer-ext-data/update`,
		headers: {
			'x-api-key': apiKey
		},
		data: data,
	};

	return await axios(config)
		.then(response => {
			const res = response.data;
			return res;
		});
};

const _deleteExternalFile = async (data) => {
	const apiUrl = process.env.REACT_APP_CUSTOMER_FILE_API_URL;
	const apiKey = process.env.REACT_APP_CUSTOMER_FILE_API_KEY;
	const config = {
		method: 'DELETE',
		url: `${apiUrl}/customer-ext-data/delete`,
		headers: {
			'x-api-key': apiKey
		},
		data: data,
	};

	return await axios(config)
		.then(response => {
			const res = response.data;
			return res;
		});
};

const _listExternalFile = async () => {
	const customer = getCustomer();
	const apiUrl = process.env.REACT_APP_CUSTOMER_FILE_API_URL;
	const apiKey = process.env.REACT_APP_CUSTOMER_FILE_API_KEY;
	const config = {
		method: 'GET',
		url: `${apiUrl}/customer-ext-data/list`,
		headers: {
			'x-api-key': apiKey
		},
		params: {
			'customer_code': customer
		},
		errorHandle: {
			message: COMMUNICATE_ERROR_MESSAGE_CUSTOMER_EXTERNAL_FILE_LIST,
			additionalMessage: COMMUNICATE_ERROR_MESSAGE_TRY_AGAIN_LATER
		}
	};

	return await axios(config)
		.then(response => {
			const res = response.data;
			return res;
		})
		.catch(() => []);
};


/* カンパニーアイコンstate */
const customerIconListState = atom({
	key: 'customerIconListState',
	default: selector({
		key: 'customerIconListStateSelector',
		get: _listCustomerIcon,
	})
});

/* カンパニーポイントstate */
const customerPointListState = atom({
	key: 'customerPointListState',
	default: selector({
		key: 'customerPointListStateSelector',
		get: _listCustomerPoint,
	})
});

/* 外部ファイルstate */
const customerExternalFileListState = atom({
	key: 'customerExternalFileListState',
	default: selector({
		key: 'customerExternalFileListStateSelector',
		get: _listExternalFile,
	})
});

export const pointAreaUpdateState = atom({
	key: 'pointAreaUpdateState',
	default: Date.now(),
});

export const useCustomerPointList = () => {
	const customerPointList = useRecoilValue(customerPointListState);
	const customerIconList = useRecoilValue(customerIconListState);
	const setPointAreaUpdate = useSetRecoilState(pointAreaUpdateState);

	const ref1 = useRecoilRefresher_UNSTABLE(customerPointListState);

	const refresher = useCallback(() => {
		ref1();
	}, [ref1]);

	const registerCustomerPoint = useCallback(data => {
		const require = [
			'name',
		];

		if(!require.every(v => v in data)) {
			throw new Error('Unset require parameter');
		};

		const iconInfoData = {
			// name: data.name,
			...data
		}

		return _registerCustomerPoint(iconInfoData)
			.then(refresher)
			.then(() => setPointAreaUpdate(Date.now()));
	}, [refresher, setPointAreaUpdate]);

	const updateCustomerPoint = useCallback((data, imageData) => {
		const require = [
			'pointId',
			'update_time',
			'update_by_user',
		];

		if (!require.every(v => v in data)) {
			throw new Error('Unset require parameter');
		};

		const iconInfoData = {
			// name: data.name,
			...data
		}

		return _updateCustomerPoint(iconInfoData)
			.then(refresher)
			.then(() => setPointAreaUpdate(Date.now()));
	}, [refresher, setPointAreaUpdate]);

	const deleteCustomerPoint = useCallback(data => {
		const require = [
			'point_id',
			'update_time',
			'update_by_user',
		];

		if (!require.every(v => v in data)) {
			throw new Error('Unset require parameter');
		};

		const iconInfoData = {
			pointId: data.point_id,
			update_time: data.update_time,
			update_by_user: data.update_by_user,
		}

		return _deleteCustomerPoint(iconInfoData)
			.then(refresher)
			.then(() => setPointAreaUpdate(Date.now()));
	}, [refresher, setPointAreaUpdate]);

	return {
		customerPointList,
		customerIconList,
		registerCustomerPoint,
		updateCustomerPoint,
		deleteCustomerPoint,
		refreshCustomerPointList: refresher,
	}
};

export const useCustomerIconList = () => {
	const companyIconList = useRecoilValue(customerIconListState);

	const ref1 = useRecoilRefresher_UNSTABLE(customerIconListState);

	const refresher = useCallback(() => {
		ref1();
	}, [ref1]);

	const registerCustomerIcon = useCallback(data => {
		const require = [
			'name',
			'customer_icon_image_blob',
		];

		if(!require.every(v => v in data)) {
			throw new Error('Unset require parameter');
		};

		const iconInfoData = {
			name: data.name,
		}

		const iconImageData = {
			customer_icon_image_blob: data.customer_icon_image_blob,
		}

		return _registerCustomerIcon(iconInfoData)
			.then(async res => {
				const iconId = res.iconId;
				const updateTime = res.update_time;
				const updateByUser = res.update_by_user;
				iconImageData.icon_id = iconId;
				iconImageData.update_time = updateTime;
				iconImageData.update_by_user = updateByUser;
				return _registerCustomerIconImage(iconImageData);
			})
			.then(refresher);
	}, [refresher]);

	const updateCustomerIcon = useCallback((data, imageData) => {
		let promise;
		if (data) {
			const require = [
				'icon_id',
				'update_time',
				'update_by_user',
			];
	
			if (!require.every(v => v in data)) {
				throw new Error('Unset require parameter');
			};

			const iconInfoData = Object.fromEntries(Object.entries(data).filter(([v]) => v !== 'icon_id'));
			iconInfoData.iconId = data.icon_id;

			promise = _updateCustomerIcon(iconInfoData);
		} else {
			promise = Promise.resolve();
		}

		return promise
			.then(async res => {
				if (imageData) {
					// if (imageData.delete) {
					// 	await Promise.all(imageData.delete.map(d => _deleteCustomerIconImage(d)));
					// }
					if (imageData.register) {
						const updateTime = res?.update_time;
						const updateByUser = res?.update_by_user;
						await Promise.all(imageData.register.map(d => {
							if (updateTime && updateByUser) {
								d.update_time = updateTime;
								d.update_by_user = updateByUser;
							}
							return _registerCustomerIconImage(d);
						}));
					}
				}
			})
			.then(refresher);
	}, [refresher]);

	const deleteCustomerIcon = useCallback(data => {
		const require = [
			'icon_id',
			'update_time',
			'update_by_user',
		];

		if (!require.every(v => v in data)) {
			throw new Error('Unset require parameter');
		};

		const iconInfoData = {
			iconId: data.icon_id,
			update_time: data.update_time,
			update_by_user: data.update_by_user,
		}

		return _deleteCustomerIcon(iconInfoData)
			.then(() => {
				refresher()
			});
	}, [refresher]);

	return {
		companyIconList,
		registerCustomerIcon,
		updateCustomerIcon,
		deleteCustomerIcon,
		refreshCustomerIconList: refresher,
	}
};

const customerExternalFileListVisibleState = selector({
	key: 'customerExternalFileListVisibleState',
	get: ({ get }) => {
		const visible = get(mapContentsVisibleWithID(MAP_ID_CUSTOM_POINT_AREA));
		if (!visible) {
			return null;
		}
		return get(customerExternalFileListState);
	}
});

export const useCustomerExternalFileListVisible = () => {
	return useRecoilValue(customerExternalFileListVisibleState);
}

export const useCustomerExternalFileList = () => {
	const user = useRecoilValue(userState);
	const customerExternalFileList = useRecoilValue(customerExternalFileListState);

	const ref1 = useRecoilRefresher_UNSTABLE(customerExternalFileListState);

	const refresher = useCallback(() => {
		ref1();
	}, [ref1]);

	const registerCustomerExternalFile = useCallback((data, fileData) => {
		const require = [
			'customer_code',
			'folder_name',
			'file_name',
			'name',
			'color',
			'size',
			'api_exec_user',
		];

		const _data = Object.assign({}, data, {
			customer_code: user.customer,
			api_exec_user: user.userId,
		});

		if(!require.every(v => v in _data)) {
			throw new Error('Unset require parameter');
		};

		const puturlData = {
			customer_code: user.customer,
			folder_name: _data.folder_name,
		}

		const promise = _getExternalFileUploadUrl(puturlData)
		.then(res => {
			_data.object_key = res.object_key;
			return _uploadExternalFile(res.url, fileData);
		});

		return promise
			.then(res => {
				return _registerExternalFile(_data);
			})
			.then(refresher)
	}, [refresher, user]);

	const updateCustomerExternalFile = useCallback((data, fileData) => {
		const require = [
			'customer_code',
			'file_id',
			'folder_name',
			'file_name',
			'name',
			'color',
			'size',
			'update_time',
			'update_by_user',
			'api_exec_user',
		];

		const _data = data.map(v => {
			const _v = Object.assign({}, v, {
				customer_code: user.customer,
				api_exec_user: user.userId,
			});

			if (!require.every(v => v in _v)) {
				throw new Error('Unset require parameter');
			};
			return _v;
		});

		if (fileData) {
			if (_data.length !== 1) {
				throw new Error('Illegal parameter');
			}
			const puturlData = {
				customer_code: user.customer,
				folder_name: _data[0].folder_name,
			}

			return _getExternalFileUploadUrl(puturlData)
				.then(res => {
					_data[0].object_key = res.object_key;
					return _uploadExternalFile(res.url, fileData);
				})
				.then(res => {
					return _replaceExternalFile(_data);
				})
				.then(refresher)
		} else {
			return _updateExternalFile(_data)
				.then(refresher);
		}
	}, [refresher, user]);

	const deleteCustomerExternalFile = useCallback(data => {
		const require = [
			'file_id',
			'update_time',
			'update_by_user',
		];

		const _data = data.map(v => {
			const _v = Object.assign({}, v, {
				api_exec_user: user.userId,
			});

			if (!require.every(v => v in _v)) {
				throw new Error('Unset require parameter');
			};
			return _v;
		})

		return _deleteExternalFile(_data)
			.then(refresher)
	}, [refresher, user]);

	return {
		customerExternalFileList,
		registerCustomerExternalFile,
		updateCustomerExternalFile,
		deleteCustomerExternalFile,
		refreshCustomerExternalFileList: refresher,
	}
};
